import * as ReactUI from 'react-bootstrap';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { darkModeState } from './atoms';
import NavBar from './components/navbar/NavBar';
import { Enter } from './components/start/Enter';
import './index.scss';
import { routes } from './routes';
import { useErrorBoundary } from './util/hooks/error';

function App() {
  const error = useErrorBoundary();
  const desktopMode = window.matchMedia('(max-width: 1199px)');
  const darkMode = useRecoilValue(darkModeState);
  const mainContainerTheme = !darkMode
    ? 'main-container'
    : 'main-container-dark';
  const menuContainerTheme = !darkMode
    ? 'menu-container'
    : 'menu-container-dark';

  const className = 'pr-0 d-none d-sm-none d-md-flex';

  return desktopMode.matches ? (
    error
  ) : (
    <Router>
      <Enter>
        <ReactUI.Row id={mainContainerTheme}>
          <ReactUI.Col md={3} className={className}>
            <NavBar />
          </ReactUI.Col>

          <ReactUI.Col id={menuContainerTheme} sm={12} md={9}>
            <Routes>
              {routes.map(([path, Element], i) => {
                return <Route key={path} path={path} element={<Element />} />;
              })}
            </Routes>
          </ReactUI.Col>
        </ReactUI.Row>
      </Enter>
    </Router>
  );
}

export default App;
